import type { FilterDescriptor } from '@progress/kendo-data-query';

/**
 * A list of filters as the query string the API takes them in.
 *
 * A plain function, and not only an action of a store: a list that asks again when its query
 * changes compares this text each time a filter is written (useReloadOnQuery), and every call of
 * a store's action is logged by the store's plugins.
 */
export const filtersToQueryString = (filters: FilterDescriptor[]): string =>
    filters.map((item: FilterDescriptor, index: number) => {
        return [
            "filter[filters]["+index+"][field]="+item.field,
            "filter[filters]["+index+"][operator]="+item.operator.toString(),
            ...Array.isArray(item.value)
                ? item.value.map((value, index2) => {
                    return "filter[filters]["+index+"][value]["+index2+"]="+encodeURIComponent(value)
                })
                : ["filter[filters]["+index+"][value]="+encodeURIComponent(item.value)],
        ].join('&')
    }).join('&') + "&filter[logic]=and";
